<template>
  <div>
    <el-form ref="artist" :model="metadata">
      <el-row>
        <el-col :span="24">
          <el-form-item label="Name" prop="name">
            <el-input
              type="text"
              v-model="metadata.name"
              @change="checkName($event)"
              clearable
            />
          </el-form-item>
          <el-form-item  label="Featured" prop="featured">
            <el-switch
              v-model="metadata.featured"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="Yes"
              inactive-text="No"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
          <el-form-item  label="Focus" prop="Focus">
            <el-switch
              v-model="metadata.focus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="Yes"
              inactive-text="No"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
          <el-form-item  label="Spotlight" prop="Spotlight">
            <el-switch
              v-model="metadata.spotlight"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="Yes"
              inactive-text="No"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
          <div>
            <p class="inline-eye">Biography</p>
            <i
              class="el-icon-view ml10"
              @click="openPreview(metadata.biography)"
            ></i>
          </div>
          <el-form-item prop="biography">
            <vue-editor
              v-model="metadata.biography"
              :editorToolbar="customToolbar"
            />
          </el-form-item>
          <div>
            <p class="inline-eye">Quote</p>
            <i
              class="el-icon-view ml10"
              @click="openPreview(metadata.quote)"
            ></i>
          </div>
          <el-form-item prop="quote">
            <vue-editor
              v-model="metadata.quote"
              :editorToolbar="customToolbar"
            />
          </el-form-item>
          <div>
            <p class="inline-eye">Press</p>
            <i
              class="el-icon-view ml10"
              @click="openPreview(metadata.press)"
            ></i>
          </div>
          <el-form-item prop="press">
            <vue-editor
              v-model="metadata.press"
              :editorToolbar="customToolbar"
            />
          </el-form-item>
          <el-form-item label="Hashtags" prop="hashtags">
            <el-input type="text" v-model="metadata.hashtags" clearable />
          </el-form-item>
<!--          <el-form-item label="Linkfire" prop="link_fire">-->
<!--            <el-input type="text" v-model="metadata.link_fire" clearable />-->
<!--          </el-form-item>-->
          <el-form-item label="Music video" prop="youtube_video">
            <el-input type="text" v-model="metadata.youtube_video" clearable />
          </el-form-item>
          <el-form-item label="Label" prop="label">
            <el-select
              v-model="metadata.label"
              clearable
              filterable
              class="mr10"
            >
              <el-option
                v-for="a in labels"
                :key="a.id"
                :value="a.id"
                :label="a.name"
              ></el-option>
            </el-select>
            <el-tooltip content="Add new label" placement="top">
              <el-button
                icon="el-icon-plus"
                type="success"
                circle
                @click="insertLabel"
              ></el-button>
            </el-tooltip>
          </el-form-item>
          <el-form-item prop="status">
            <el-switch
              v-model="metadata.active"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="Published"
              inactive-text="Not Published"
            ></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <Preview :previewText="text" />
    <DialogLabel />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { VueEditor } from 'vue2-editor'
import Preview from '@/global/components/Preview'
import DialogLabel from '../../new-releases/components/DialogLabel'
export default {
  components: {
    VueEditor,
    Preview,
    DialogLabel
  },
  watch: {
    dialog_label: function(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.getLabel()
      }
    }
  },
  data() {
    return {
      text: ''
    }
  },

  computed: {
    ...mapState('newReleasesArtists', ['metadata', 'labels']),
    ...mapState('newReleasesLabels',
      {dialog_label: 'dialog'})
  },

  methods: {
    ...mapActions('newReleasesArtists', ['checkArtist', 'getLabel']),
    ...mapMutations('global', ['setPreview']),
    ...mapMutations('newReleasesLabels',
      {setLabelDialog: 'setDialog'}
    ),
    openPreview(sometext) {
      this.setPreview(true)
      this.text = sometext
    },
    checkName(val) {
      this.checkArtist(val)
    },
    insertLabel() {
      this.setLabelDialog(true)
    }
  },

  created() {
    this.getLabel()
  }
}
</script>

<style scoped>
.inline-eye {
  display: inline-block;
}
</style>
